const constants = {
	// uploader state constants
	STOPPED: 1,
	STARTED: 2,
	// file status constants
	QUEUED: 1,
	UPLOADING: 2,
	FAILED: 4,
	DONE: 5,
	// error constants
	GENERIC_ERROR: -100,
	HTTP_ERROR: -200,
	IO_ERROR: -300,
	SECURITY_ERROR: -400,
	INIT_ERROR: -500,
	FILE_SIZE_ERROR: -600,
	FILE_EXTENSION_ERROR: -601,
	FILE_DUPLICATE_ERROR: -602,
	IMAGE_FORMAT_ERROR: -700,
	MEMORY_ERROR: -701,
	IMAGE_DIMENSIONS_ERROR: -702,
};

export default constants;
